import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import ScheduleRoundedIcon from '@mui/icons-material/ScheduleRounded';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import { useMemo } from 'react';
import { PowerPlayerBoltInlineIcon } from '../../assets/powerPlayerBoltInlineIcon';
import { TwemojiWrapper } from '../../components/twemojiWrapper';
import { DualLimitIcon } from '../../icons/dualLimitIcon';
import { FireIcon } from '../../icons/fireIcon';
import { ALL_IN_GAME_DARK_RED_COLOR, JACKS_COLOR } from '../../styles/colors';
import { ROOM_NAME_HYPERLINK_CSS } from '../../styles/styles';
import { ALL_POKER_VARIANT_PROPERTIES } from '../../types/pokerVariantTypes';
import { getCurrencyAmountString } from '../../utils/currencyUtils';
import { getHtmlTextContent } from '../../utils/htmlUtils';
import { getDefaultNumSeats } from '../../utils/numSeatsUtils';
import { MixedGameLabel } from '../mixedGameLabel';
import { LOBBY_ROOM_CHIP_CSS, RoomDisplayFirstRowContainer } from './lobbyRoomDisplay';
const ROOM_NAME_CSS = css(css `
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-grow: 1;
  `, ROOM_NAME_HYPERLINK_CSS);
export const JACKS_CHIP_CSS = css `
  &.MuiChip-root {
    background-color: ${JACKS_COLOR};
  }
  .MuiChip-label {
    color: black;
  }
`;
const FIRE_ICON_CSS = css `
  color: ${ALL_IN_GAME_DARK_RED_COLOR};
`;
function getVariantName(lobbyPokerVariant) {
    if (lobbyPokerVariant === 'mixed') {
        return 'Mixed Game';
    }
    return ALL_POKER_VARIANT_PROPERTIES[lobbyPokerVariant].name;
}
function getVariantShortName(lobbyPokerVariant) {
    if (lobbyPokerVariant === 'mixed') {
        return _jsx(MixedGameLabel, { label: 'Mixed' });
    }
    return ALL_POKER_VARIANT_PROPERTIES[lobbyPokerVariant].shortName;
}
export const LobbyRoomFirstRowDisplay = ({ lobbyRoom, ariaElementId }) => {
    const { numSeats, isTourneyTable, isAutoMtt, isMtt, lobbyPokerVariant, buyin, hasBuyInRange, minBuyIn, maxBuyIn, currency, isAggroBettingFilterEnabled, isPowerPlayersOnly, isDualLimitRoom } = lobbyRoom;
    const buyInStr = hasBuyInRange && minBuyIn < maxBuyIn
        ? `${getCurrencyAmountString(minBuyIn, currency, false)}—${getCurrencyAmountString(maxBuyIn, currency, false)}`
        : getCurrencyAmountString(buyin, currency, false);
    const buyInStrWithJacksLabel = hasBuyInRange && minBuyIn < maxBuyIn
        ? `${getCurrencyAmountString(minBuyIn, currency)} — ${getCurrencyAmountString(maxBuyIn, currency)}`
        : getCurrencyAmountString(buyin, currency);
    // If the room name had HTML characters in it such as < or >, these will result in '&lt;' and '&gt;' so we need to convert them back:
    const parsedRoomName = useMemo(() => getHtmlTextContent(lobbyRoom.roomName), [lobbyRoom.roomName]);
    return (_jsxs(RoomDisplayFirstRowContainer, { children: [isPowerPlayersOnly && (_jsx(PowerPlayerBoltInlineIcon, { powerPlayerBoltColor: 'black', title: 'Power Players Only', marginLeftPx: 0 })), isTourneyTable && (_jsx(Chip, { "data-testid": 'tourney-indicator', icon: isAutoMtt ? _jsx(ScheduleRoundedIcon, {}) : undefined, label: isMtt ? 'MTT' : 'TOURNEY', title: isMtt ? 'Multi Table Tournament' : 'Single Table Tournament' })), lobbyRoom.roomDisplayType === 'all_in' && (_jsx(Chip, { icon: _jsx(FireIcon, { color: 'inherit', css: FIRE_ICON_CSS }), label: 'ALL-IN', title: 'All-Insanity' })), _jsx(Typography, { id: ariaElementId, css: ROOM_NAME_CSS, variant: 'h6', children: _jsx(TwemojiWrapper, { children: parsedRoomName }) }), isAggroBettingFilterEnabled && (_jsx(Chip, { css: LOBBY_ROOM_CHIP_CSS, label: 'ABF', size: 'small', title: 'Aggro Betting Filter' })), numSeats !== getDefaultNumSeats() && numSeats > 0 && (_jsx(Chip, { css: LOBBY_ROOM_CHIP_CSS, label: `${numSeats} Seats`, size: 'small' })), _jsx(Typography, { title: getVariantName(lobbyPokerVariant), children: getVariantShortName(lobbyPokerVariant) }), isDualLimitRoom && (_jsx("span", { title: 'Dual Limit', children: _jsx(DualLimitIcon, {}) })), _jsx(Typography, { title: `Buy-in: ${buyInStrWithJacksLabel}`, children: buyInStr }), currency === 'jacks' && (_jsx(Chip, { css: JACKS_CHIP_CSS, label: 'JACKS', size: 'small', title: 'Game plays with Jacks, not Chips' }))] }));
};
